// This  is done due to the way ES6 handles importing and require statements.
// All import statements are hoisted to the top of the file before the require
// statements are run. in application.js, this causes jQuery to not be found.
// webpack's providePlugin solved the issue in the app, but not in the tests,
// so we went with this polyfill method.
window.jQuery = require('jquery');

window.$ = window.jQuery;
